import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { VerticalGuttersTitle } from "../../../Constants/Constants";
import { VerticalGuttersSubTitle } from "../../../Data/UiKits/Grid";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const VerticalGutters = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={VerticalGuttersTitle} span={VerticalGuttersSubTitle} />
        <CardBody className="v-gutter">
          <Container className="overflow-hidden text-center">
            <Row className="gy-3">
              {dynamicNumber(4).map((item, index) => (
                <Col xs="6">
                  <div className="p-3">
                    <span>Custom column padding</span>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VerticalGutters;
